import axios from "axios";

const wayApiInstance = axios.create({
  baseURL: ('https://odoo.assistant.erg.kz/api/' || ''),
});

export default wayApiInstance;
export { wayApiInstance as wayApi };